// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import trackError from 'utils/trackError';
import ErrorPage from 'pages/ErrorPage';
import NotFoundPage from 'pages/NotFoundPage';

type OwnProps = {
  children: React.Node,
  renderErrorPage?: Object => React.Node,
  renderNotFoundPage?: () => React.Node
};

type Props = {
  ...$Exact<OwnProps>,
  error: ?Object
};

type State = {
  error: ?Object
};

class ErrorBoundary extends React.Component<Props, State> {
  state = {
    error: null // error from uncaught exception
  };

  componentDidCatch(error: Error, info: { componentStack: string }) {
    this.setState({ error });
    if (window.trackJs && window.trackJs.track) {
      window.trackJs.console.log(`stacktrace:\n${info.componentStack}`);
    }
    trackError(error);
  }

  render() {
    const error = this.state.error || this.props.error;
    if (error) {
      if (error.statusCode === 404) {
        if (this.props.renderNotFoundPage) {
          return this.props.renderNotFoundPage();
        }
        return <NotFoundPage />;
      }

      if (this.props.renderErrorPage) {
        return this.props.renderErrorPage(error);
      }
      return <ErrorPage error={error} />;
    }
    return this.props.children;
  }
}

const mapStateToProps = ({ error }) => ({ error });

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(
  ErrorBoundary
);
